import { getLocaleOverride, getParentLocale } from '@eventbrite/i18n';
import { StatsigOptions, StatsigUser } from 'statsig-js';
import { STATSIG_OVERRIDE_PARAM } from '../constants/statsig';
import { isInitiallyLoggedInUser } from '../selectors/user';
import { CheckoutState } from '../state';

export const getStatsigUser = (state: CheckoutState): StatsigUser => {
    const {
        app: { appVersion, event, locale, request },
        user,
    } = state;

    return {
        appVersion,
        custom: {
            isInitiallyLoggedInUser: isInitiallyLoggedInUser(state),
        },
        customIDs: {
            correlationId: request?.correlation_id,
            eventId: event?.id,
            organizerId: event?.organizer_id,
            sessionId: request?.session_id,
        },
        locale: getParentLocale(getLocaleOverride() || locale),
        userID: user?.publicId,
        ...(typeof window !== 'undefined'
            ? { userAgent: window.navigator.userAgent }
            : {}),
    };
};

export const getStatsigOptions = (): StatsigOptions => ({
    environment: {
        tier: process.env.NODE_ENV as any,
    },
});

export const getExperimentValueToOverride = (
    { app: { isProd, request } }: CheckoutState,
    experimentName: string,
): string | null => {
    if (isProd) {
        return null;
    }

    const [experimentToOverride, valueToOverride] =
        request?.params?.[STATSIG_OVERRIDE_PARAM]?.split(':') || [];

    return experimentToOverride === experimentName ? valueToOverride : null;
};
